import { ProductRefreshPreviewToggle } from './ProductRefreshPreviewToggle';
const hideOnSmallViewportCss = "hndez20";

/** Chrome-slot wrapper: bordered toggle, hidden on small viewports (matches former AppBar mount). */
export function ProductRefreshPreviewChromeSlot() {
  return <div className={hideOnSmallViewportCss}>
      <ProductRefreshPreviewToggle showBorder />
    </div>;
}

require("./ProductRefreshPreviewChromeSlot.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ProductRefreshPreviewChromeSlot.tsx");